export function ownerLabel(person) {
  const name = [person?.first_name, person?.last_name].filter(Boolean).join(' ').trim();
  return name || person?.email || person?.assigned_name || 'Assigned';
}

/**
 * People an admin or country-scoped supervisor can filter the inbox by.
 * The signed-in user is omitted here because the menu lists them as Mine.
 */
export function inboxOwnerChoices({ assignees = [], chats = [], userId, isAdmin = false, countries = [] }) {
  const scope = new Set((countries || []).map((country) => String(country)));
  const byId = new Map();
  const add = (id, name) => {
    const key = String(id || '');
    if (!key || key === String(userId || '')) return;
    if (!byId.has(key)) byId.set(key, name || 'Assigned');
  };

  (assignees || []).forEach((person) => {
    if (!isAdmin) {
      if (!scope.size) return;
      const theirs = person?.countries || [];
      if (!theirs.some((country) => scope.has(String(country)))) return;
    }
    add(person.user_id, ownerLabel(person));
  });

  (chats || []).forEach((item) => {
    (item?.leads || []).forEach((lead) => {
      if (lead?.assigned_to) add(lead.assigned_to, lead.assigned_name);
    });
  });

  return [...byId.entries()]
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function chatMatchesOwner(item, ownerFilter, userId) {
  if (!ownerFilter) return true;
  const target = ownerFilter === 'mine' ? String(userId || '') : String(ownerFilter);
  if (!target) return false;
  return (item?.leads || []).some((lead) => String(lead?.assigned_to || '') === target);
}
